import { __decorate } from 'tslib';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import SgdsElement from '../../base/sgds-element.js';
import css_248z from './sgds-progress2.js';
import { html } from 'lit';

/**
 * @summary Provide up-to-date feedback on the progress of a workflow or action with simple yet flexible progress bars.
 * @slot default - slot for progress-bar
 *
 * @cssprop --progress-height - Sets the height of the progress wrapper.
 */
class SgdsProgress extends SgdsElement {
    render() {
        return html `
      <div
        class=${classMap({
            progress: true,
            [`${this.progressClasses}`]: this.progressClasses
        })}
      >
        <slot></slot>
      </div>
    `;
    }
}
SgdsProgress.styles = [SgdsElement.styles, css_248z];
__decorate([
    property({ type: String, reflect: true })
], SgdsProgress.prototype, "progressClasses", void 0);

export { SgdsProgress, SgdsProgress as default };
//# sourceMappingURL=sgds-progress.js.map
